<template>
    <div>
        <data-table-component :url="`/api/users/${userId}/subscriptions`" order-by="2" sort-by="desc" :columns="columns" :is-searchable="false" table-container-class="data-table shadow-none">
            <template slot-scope="{ row }" slot="filters">
                <slot v-bind="row"></slot>
            </template>
            <template slot-scope="{ row }" slot="actions">
                <td class="text-right">
                    <a :href="`/admin/users/${userId}/subscriptions/${row.id}/edit`" class="button is-small is-tertiary inline-block">
                        <i class="fas fa-edit"></i>
                    </a>
                </td>
            </template>
        </data-table-component>
    </div>
</template>

<script>
    import DataTableComponent from '../DataTableComponent';
    import moment from 'moment';

    export default {
        components: {
            DataTableComponent,
        },

        props: {
            user: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                columns: [
                    {
                        id: 'code',
                        key: 'code',
                        label: 'Code',
                        html: (key, value, row) => {
                            return row.code.toUpperCase();
                        }
                    },
                    {
                        id: 'name',
                        key: 'name',
                        label: 'Name',
                        html: (key, value, row) => {
                            return row.name;
                        }
                    },
                    {
                        id: 'year',
                        key: 'year',
                        label: 'Year',
                        html: (key, value, row) => {
                            return row.year;
                        }
                    },
                    {
                        id: 'amount',
                        key: 'amount',
                        label: 'Amount',
                        html: (key, value, row) => {
                            return row.symbol + row.amount;
                        }
                    },
                    {
                        id: 'active',
                        key: 'active',
                        label: 'Active',
                        html: (key, value, row) => {
                            if (value == 1) {
                                return '<i class="fas fa-check text-green"></i>';
                            }

                            return '<i class="fas fa-times text-red"></i>';
                        }
                    },
                    {
                        id: 'is_paid',
                        key: 'is_paid',
                        label: 'Paid',
                        html: (key, value, row) => {
                            if (value == 1) {
                                return '<i class="fas fa-check text-green"></i>';
                            }

                            return '<i class="fas fa-times text-red"></i>';
                        }
                    },
                    {
                        id: 'is_void',
                        key: 'is_void',
                        label: 'Void',
                        html: (key, value, row) => {
                            if (value == 1) {
                                return '<i class="fas fa-check text-green"></i>';
                            }

                            return '<i class="fas fa-times text-red"></i>';
                        }
                    },
                ],

                userId: this.user,

                currentRow: {},
                isDeleteModalVisible: false,
            }
        }
    }
</script>
